export interface ParsedTxError {
  kind: 'rejected' | 'failed';
  message: string;
}

const REJECT_PATTERNS = [
  /user rejected/i,
  /user denied/i,
  /request rejected/i,
  /transaction was rejected/i,
  /rejected by user/i,
  /signature.*denied/i,
];

const isRejection = (err: any, message: string): boolean => {
  if (!err) return false;
  if (err.name === 'UserRejectedRequestError') return true;
  if (err.code === 4001 || err.code === 'ACTION_REJECTED') return true;
  let cursor: any = err.cause;
  let depth = 0;
  while (cursor && depth < 5) {
    if (cursor.name === 'UserRejectedRequestError') return true;
    if (cursor.code === 4001 || cursor.code === 'ACTION_REJECTED') return true;
    cursor = cursor.cause;
    depth++;
  }
  return REJECT_PATTERNS.some((p) => p.test(message));
};

const collectShortMessages = (err: any): string[] => {
  const out: string[] = [];
  let cursor: any = err;
  let depth = 0;
  while (cursor && depth < 6) {
    if (typeof cursor.shortMessage === 'string' && cursor.shortMessage.trim()) {
      out.push(cursor.shortMessage.trim());
    }
    if (typeof cursor.reason === 'string' && cursor.reason.trim()) {
      out.push(cursor.reason.trim());
    }
    cursor = cursor.cause;
    depth++;
  }
  return out;
};

const trimViemNoise = (raw: string): string => {
  if (!raw) return raw;
  const cutKeys = [
    '\nRequest Arguments:',
    '\nContract Call:',
    '\nDocs:',
    '\nDetails:',
    '\nVersion:',
    'Request Arguments:',
    'Contract Call:',
    'Docs:',
    'Details:',
    'Version:',
  ];
  let out = raw;
  for (const k of cutKeys) {
    const idx = out.indexOf(k);
    if (idx > 0) out = out.slice(0, idx);
  }
  return out.replace(/\s+/g, ' ').trim().replace(/\.+$/, '') + '.';
};

export const parseTxError = (err: any, fallback = 'Transaction failed.'): ParsedTxError => {
  if (!err) return { kind: 'failed', message: fallback };

  const rawMessage = typeof err.message === 'string' ? err.message : '';
  if (isRejection(err, rawMessage)) {
    return { kind: 'rejected', message: 'Transaction rejected in wallet.' };
  }

  const shortMessages = collectShortMessages(err);
  if (shortMessages.length > 0) {
    return { kind: 'failed', message: trimViemNoise(shortMessages[0]) };
  }

  if (rawMessage) {
    return { kind: 'failed', message: trimViemNoise(rawMessage) };
  }

  return { kind: 'failed', message: fallback };
};
